<template>
  <div class="Pack">
    <div class="page-title">{{ title }}</div>
    <ATable
      ref="table"
      max-height="365px"
      v-loading="loading"
      :placeholder="placeholder"
      :search_field="search_field"
      :data="items"
      hide-button-insert
      highlight-current-row
      hide-pagination
      border
      @row-click="handleClickRow"
    >
      <div slot="search">
        <div class="inline">
          <APeriodSelector
            ref="period"
            value="1w"
            @change="handleChangePeriod"
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
            >{{ $t("button.search") }}(F5)</el-button
          >
        </div>
      </div>
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
        align="center"
      />
      <el-table-column prop="code" label="수주번호" width="100" />
      <el-table-column
        prop="customer_name"
        :label="$t('lang.customer_name')"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column
        prop="product_name"
        label="품목"
        min-width="120"
        :formatter="resolveProductName"
        show-overflow-tooltip
      />
      <el-table-column
        prop="destination"
        :label="$t('lang.destination')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="contract_date"
        :label="$t('lang.contract_date')"
        :width="$width.date"
      />
      <el-table-column
        prop="delivery_date"
        :label="$t('lang.delivery_date')"
        :width="$width.date"
      />
      <el-table-column
        prop="delivery_way_flag"
        :label="$t('lang.shipping_mode')"
        width="100"
      >
        <template slot-scope="scope">{{
          resolveDeliveryWayFlag(scope.row.delivery_way_flag)
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('lang.state')" align="center" width="60">
        <template slot-scope="scope">{{
          resolvePackageFlag(scope.row.package_flag)
        }}</template>
      </el-table-column>
    </ATable>
    <div v-show="selectedData">
      <div class="row-splitter">
        <div class="inline info-field">
          <el-input v-model="code" readonly>
            <template slot="prepend">수주번호</template>
          </el-input>
        </div>
        <div class="inline info-field">
          <el-input v-model="customer_name" readonly>
            <template slot="prepend">상 호</template>
          </el-input>
        </div>
        <div class="inline info-field">
          <el-input v-model="destination" readonly>
            <template slot="prepend">도 착 지</template>
          </el-input>
        </div>
      </div>
      <div class="row-splitter">
        <ATable
          ref="table2"
          class="no-pointer"
          buttons-width="500px"
          max-height="365px"
          :data="details"
          hide-button-insert
          hide-button-excel
          hide-pagination
          border
          @selection-change="handleSelectionChange"
        >
          <div slot="search">
            <div class="page-subtitle">{{ $t("lang.list_Packing") }}</div>
          </div>
          <el-table-column
            type="selection"
            align="center"
            :width="$width.selection"
            :selectable="selectable"
          />
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex2"
            :width="$width.index"
            align="center"
          />
          <el-table-column
            prop="product_name"
            :label="$t('lang.material_name')"
            show-overflow-tooltip
          />
          <el-table-column
            prop="size"
            :label="$t('lang.size')"
            width="100"
            show-overflow-tooltip
          />
          <el-table-column
            prop="unit_name"
            :label="$t('lang.unit')"
            width="80"
          />
          <el-table-column
            prop="amount"
            :label="$t('lang.quantity')"
            width="60"
          />
          <el-table-column
            prop="desc"
            :label="$t('lang.desc')"
            show-overflow-tooltip
          />
          <el-table-column
            prop="production_amount"
            label="생산"
            align="center"
            width="80"
          />
          <el-table-column
            prop="package_flag"
            label="검수"
            align="center"
            width="80"
            :formatter="resolveDetailPackageFlag"
          />
          <div slot="buttons">
            <el-button
              type="primary"
              :disabled="!isPackable || !has_grant_write"
              @click="handleClickCheck"
              >{{ $t("button.packaging_acceptance") }}</el-button
            >
            <el-button
              type="primary"
              :disabled="!isCompletable || !has_grant_write"
              @click="handleClickFinish"
              >{{ $t("button.packaging_finish") }}</el-button
            >
            <el-button @click="handleClickPrint">{{
              $t("button.list_printing")
            }}</el-button>
            <el-button
              type="danger"
              :disabled="!isCancelable || !has_grant_write"
              @click="handleClickCancel"
              >{{ $t("button.packaging_cancelled") }}</el-button
            >
          </div>
        </ATable>
      </div>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="출력 리스트"
      width="900px"
      style="height: 100%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      destroyOnClose
    >
      <TransactionPrint
        ref="print"
        :data="selectedData"
        @completed="handleCompletePrint"
      />
    </el-dialog>
  </div>
</template>
<script>
import { authority_level } from "@/common/mixins/authority_level";
import TransactionPrint from "./TransactionPrint";

export default {
  name: "Pack",
  mixins: [authority_level],
  components: { TransactionPrint },
  data() {
    return {
      title: this.$t("title.production_pack"),
      search_field: ["code", "customer_name", "location", "owner"],
      placeholder: "명세서번호, 거래처, 도착지, 주문자",
      loading: false,
      items: [],
      period: {},
      selectedData: null,
      selection: [],
      dialogVisible: false,
      code: "",
      customer_name: "",
      destination: "",
      delivery_way_flag: "",
    };
  },
  computed: {
    isPackable() {
      if (this.selection.length < 1) {
        return false;
      }
      let hasUnpacked = false;
      this.selection.forEach((s) => {
        if (s.package_flag !== "Y") {
          hasUnpacked = true;
          return true;
        }
      });
      return hasUnpacked;
    },
    isCompletable() {
      if (!this.selectedData) {
        return false;
      }
      let hasUnpacked = false;
      this.details.forEach((s) => {
        if (s.package_flag !== "Y") {
          hasUnpacked = true;
          return true;
        }
      });
      return this.selectedData.package_flag !== "Y" && !hasUnpacked;
    },
    isCancelable() {
      if (!this.selectedData) {
        return false;
      }
      return this.selectedData.package_flag === "Y";
    },
    details() {
      if (!this.selectedData) {
        return [];
      }
      return this.selectedData.details;
    },
    has_grant_write() {
      return this.isWriteLevel("production_pack");
    },
  },
  watch: {
    selectedData: function(val) {
      if (val) {
        this.code = val.code;
        this.customer_name = val.customer_name;
        this.destination = val.destination + " ";
        this.delivery_way_flag = val.delivery_way_flag;
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listContractPackage(this.period).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
        this.loading = false;
      });
    },
    selectable(row /*, index*/) {
      return row.goods.length == 0 || row.amount === row.production_amount;
    },
    doFinish() {
      this.loading = true;
      this.api.updateContractPackageFinish(this.selectedData).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
        this.selectedData = res.data;
      });
    },
    doCancel() {
      this.loading = true;
      this.api.updateContractPackageCancel(this.selectedData).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
        this.selectedData = res.data;
      });
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleIndex2(index) {
      return this.$refs.table2.indexResolver(index);
    },
    handleClickRow(data) {
      this.selectedData = data;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickCheck() {
      if (this.selection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      let selection = [];
      this.selection.map((s) => selection.push(s.id));
      let params = { id: this.selectedData.id, details: selection };
      this.api.updateContractPackageCheck(params).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
        this.selectedData = res.data;

        if (this.isCompletable) this.handleClickFinish();
      });
    },
    handleClickFinish() {
      this.util.confirm(
        this,
        this.title,
        "포장을 완료하시겠습니까?",
        this.doFinish
      );
    },
    handleClickPrint() {
      this.dialogVisible = true;
    },
    handleClickCancel() {
      this.util.confirm(
        this,
        this.title,
        "포장을 취소하시겠습니까?",
        this.doCancel
      );
    },
    handleCompletePrint() {
      this.dialogVisible = false;
    },
    resolveDeliveryWayFlag(val) {
      let flag = this.system.options.delivery_way_flag.find(
        (f) => f.value === val
      );
      if (!flag) return "";
      return flag.label;
    },
    resolveProductionFlag(val) {
      if (val === "Y") {
        return "완료";
      } else {
        return "";
      }
    },
    resolvePackageFlag(val) {
      if (val === "Y") {
        return "완료";
      } else {
        return "진행";
      }
    },
    resolveDetailPackageFlag(row, column, value) {
      if (row.specification) {
        return "사양";
      } else {
        if (value === "Y") {
          return "검수";
        } else {
          return "미확인";
        }
      }
    },
    resolveProductName(row) {
      if (row.details.length > 1) {
        return (
          row.details[0].product_name + " 외 " + (row.details.length - 1) + "건"
        );
      } else if (row.details.length === 1) {
        return row.details[0].product_name;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-field {
  width: 23%;
  &:not(:last-child) {
    padding-right: 20px;
  }
}
</style>
